module.exports = __webpack_public_path__ + "img/design_tpintxo.6bfc33e0.jpg";